import { StyleSheet } from '@react-pdf/renderer'

export const styles = StyleSheet.create({
  metrics: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  metricLabel: {
    fontSize: 5,
    color: '#898C9A',
    fontWeight: 300,
    marginBottom: 2,
  },
  discount: {
    marginTop: 5,
    fontSize: 8,
  },
  bioWrapper: {
    flexBasis: '60%',
    paddingTop: 4,
  },
  bio: {
    fontSize: 6,
  },
  metricValue: {
    fontSize: 10,
  },
  metricSeparator: {
    width: 0.5,
    height: 15,
    backgroundColor: '#D6D6D6',
    marginHorizontal: 10,
  },
  promoTitle: {
    marginBottom: 1,
  },
  leftBlock: {
    flexBasis: '70%',
  },
  rightBlock: {
    flexBasis: '30%',
    gap: 10,
  },
  account: {
    flexDirection: 'row',
    alignItems: 'flex-start',
  },
  accountWrapper: {
    flexBasis: '40%',
  },
})
